import { deleteApi, getApi, postApi, putApi } from "../apiCall";

export const walletAccountApi = ({ role, id }) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/wallet-account/${role}/${id}`;
  return getApi(url);
};

export const walletTransactionApi = () => {
  let url = `${process.env.REACT_APP_API_URL}/payments/wallet-account/activities?currentPage=0&size=10000`;
  return getApi(url);
};

export const walletContractApi = ({ id }) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/transaction/scheduled/${id}?currentPage=0&size=10000`;
  return getApi(url);
};

export const walletChildTransaction = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/transaction/${id}/child?currentPage=0&size=100000`;
  return getApi(url);
};

export const chargesLosses = () => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/loses`;
  return getApi(url);
};

export const chargesObligation = () => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/obligation`;
  return getApi(url);
};

export const chargesUser = () => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/user`;
  return getApi(url);
};

export const createCharge = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges`;
  return postApi(url, payload);
};

export const createNewCharge = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/default`;
  return postApi(url, payload);
};

export const updateNewCharge = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/default`;
  return putApi(url, payload);
};

export const deteteNewCharge = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/default/${id}`;
  return deleteApi(url);
};

export const deleteDefaultCharges = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/${id}`;
  return deleteApi(url);
};

export const updateCharge = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/entity`;
  return putApi(url, payload);
};

export const assignCharge = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/assign`;
  return postApi(url, payload);
};

export const removeCharges = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/re-assign`;
  return deleteApi(url, payload);
};

export const consumerCharges = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/consumers`;
  return postApi(url, payload);
};

export const generatorCharges = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/generators`;
  return postApi(url, payload);
};

export const bilateralContractCreate = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/bilateral-contract/create`;
  return postApi(url, payload);
};

export const getContractCharges = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/bilateral-contract/${id}`;
  return getApi(url);
};

export const updateContract = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/charges/bilateral-contract/approve-reject`;
  return putApi(url, payload);
};

export const getWalletAccountsByCompanies = (companyIds) => {
  const ids = companyIds.join(",");
  const url = `${process.env.REACT_APP_API_URL}/payments/wallet-account/by-companies?companyIds=${ids}`;
  return getApi(url);
};

export const getContractPayouts = ({ id, repid }) => {
  const url = `${process.env.REACT_APP_API_URL}/payments/pushTxnFile/by-bilateral-contract-id?bilateralContractIds=${id}&repScheduleId=${repid}`;
  return getApi(url);
};

export const walletAccountCreate = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/wallet-account/create-entity-wallet`;
  return postApi(url, payload);
};
